import '.a6{position:absolute;}.ssr-plugin'
import '.cf{top:0px;}.ssr-plugin'
import '.ag{left:0px;}.ssr-plugin'
import '.be{right:0px;}.ssr-plugin'
import '.c2{overflow:hidden;}.ssr-plugin'
import '.cg{height:100dvh;}.ssr-plugin'
import '.ch{outline:3px solid yellow;}.ssr-plugin'
import { styled } from 'inlines'
import { Slider } from '../components/Slider.js'
import { Logo } from '../assets/svg/Logo.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { MOBILE } from '../utils/breakpoints.js'
import { useLive } from '../hooks/useLive.js'
import { useVotes } from '../hooks/useVotes.js'
import { usePhoneVotesCast } from '../hooks/usePhoneVotesCast.js'
import { useScrollToTop } from '../hooks/useScrollToTop.js'
import { useEffect } from 'react'

export const ThankYouPage = () => {
  const track = useTrack('thankyou')
  const { votingRegion, contestants } = useLive()

  const [votes, setVotes] = useVotes()

  if (Object.keys(votes)?.length > 0) {
    setVotes({})
  }

  useScrollToTop()

  const thanks = window.location.href.split('/')
  const arrOfCandidateCodes = thanks[thanks.length - 1].split('-')

  const [phoneVotesCast] = usePhoneVotesCast()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  const isPhoneVote = votingRegion?.voteType !== 'online'

  let phoneContestant = contestants?.find(
    (x) => x.id === Number(arrOfCandidateCodes[0]),
  )
  const videosLength = phoneContestant?.thankYouVideos?.length ?? 0
  const votesCast = phoneVotesCast[phoneContestant?.votingRegion] ?? 0
  const thankVidNumber = Math.min(
    Math.max(votesCast - 1, 0),
    Math.max(videosLength - 1, 0),
  )

  const SmsThankYouVideo = [
    {
      src:
        phoneContestant?.thankYouVideos[thankVidNumber]?.hls ||
        phoneContestant?.thankYouVideos[thankVidNumber]?.src,
      poster: phoneContestant?.image?.src,
    },
  ]

  // This if for normal votes
  const thankYouVideosArr =
    contestants
      .filter(
        (item) =>
          arrOfCandidateCodes.includes(item?.votingRegion) &&
          (item?.storyThankYouVideo?.src || item.storyThankYouVideo?.hls),
      )
      .map((item) => ({
        src: item.storyThankYouVideo?.hls || item.storyThankYouVideo?.src,
        poster: item.image?.src,
      })) || []

  return (
    <div className="a6 cf ag be c2 cg ch"
      id="thanks-page-content"
    >
      <Logo
        style={{
          left: '50%',
          position: 'absolute',
          transform: 'translateX(-50%)',
          top: 24,
          zIndex: 1,
          [MOBILE]: {
            top: '48px',
          },
        }}
        width={96}
        height={32}
      />
      <Slider
        arr={isPhoneVote ? SmsThankYouVideo : thankYouVideosArr}
        phoneContestant={phoneContestant}
      />
    </div>
  )
}
